import type { components } from '@customerio/hydra-ui-api';

/**
 * A workspace push app (mobile app registration). `id` + `name` +
 * `is_default` serve the delivery detail (resolving a push delivery's
 * `app_id` to its app name) and the Design Studio inbox styles section
 * (INAPP-14649); `platforms` serves the people condition builder's
 * `app_identifier` picker, whose option values are the per-platform bundle
 * identifiers a device reports.
 */
export type PushApp = Pick<
  components['schemas']['services_ui_api_apps_appModel'],
  'id' | 'name' | 'is_default' | 'platforms'
>;

// The active read sits under the `['workspace', id, …]` subtree so a workspace
// switch's `removeQueries({ queryKey: ['workspace', prevId] })` evicts it. The
// no-workspace sentinel sits outside that namespace and never receives data (its
// query uses `skipToken`), so there is nothing to evict there.
export const appKeys = {
  list: (workspaceId: number) => ['workspace', workspaceId, 'app', 'list'] as const,
  noWorkspace: () => ['app', 'no-workspace'] as const,
};
